/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceProtocolUpdateDto
 */
export interface DeviceProtocolUpdateDto {
    /**
     * Requested protocol for the device. Must be one of the SupportedProtocol values.
     * @type {string}
     * @memberof DeviceProtocolUpdateDto
     */
    protocol?: DeviceProtocolUpdateDtoProtocolEnum;
    /**
     * If true, restart the device after updating the protocol. This is required for the new protocol to take effect as we can only choose the protocol for connection when a device initiates a connection.
     * @type {boolean}
     * @memberof DeviceProtocolUpdateDto
     */
    restartDevice?: boolean;
}

/**
 * @export
 */
export const DeviceProtocolUpdateDtoProtocolEnum = {
    Unknown: "Unknown",
    Ocpp16: "ocpp1.6",
    Jcwp18: "jcwp1.8",
    Jclp11: "jclp1.1",
    Jccp: "jccp",
    JcppPb: "jcpp-pb",
    Ocpp201: "ocpp2.0.1",
} as const;
export type DeviceProtocolUpdateDtoProtocolEnum =
    (typeof DeviceProtocolUpdateDtoProtocolEnum)[keyof typeof DeviceProtocolUpdateDtoProtocolEnum];

/**
 * Check if a given object implements the DeviceProtocolUpdateDto interface.
 */
export function instanceOfDeviceProtocolUpdateDto(
    value: object,
): value is DeviceProtocolUpdateDto {
    return true;
}

export function DeviceProtocolUpdateDtoFromJSON(
    json: any,
): DeviceProtocolUpdateDto {
    return DeviceProtocolUpdateDtoFromJSONTyped(json, false);
}

export function DeviceProtocolUpdateDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceProtocolUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        protocol: json["protocol"] == null ? undefined : json["protocol"],
        restartDevice:
            json["restartDevice"] == null ? undefined : json["restartDevice"],
    };
}

export function DeviceProtocolUpdateDtoToJSON(
    value?: DeviceProtocolUpdateDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        protocol: value["protocol"],
        restartDevice: value["restartDevice"],
    };
}
